import script from "./KanbanColumnWeekly.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanColumnWeekly.vue?vue&type=script&setup=true&lang=js"

import "./KanbanColumnWeekly.vue?vue&type=style&index=0&id=a7d31314&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7d31314"]])

export default __exports__